import type { ContractAmendment } from '@/types'

/**
 * Текущая сторона ДКК = юрлицо подписанного оригинала с применёнными на бизнес-дату
 * ENTITY_CHANGE-событиями. contract_party_intervals закрыта для чтения из фронта,
 * поэтому все экраны используют один и тот же клиентский resolver.
 */
export function resolveCurrentContractEntityId(
  baseEntityId: number | null,
  amendments: ContractAmendment[],
  businessDate: string,
): number | null {
  const entityChanges = amendments
    .filter((amendment) => (
      amendment.amendment_type === 'ENTITY_CHANGE'
      && amendment.new_entity_id != null
      && amendment.effective_from <= businessDate
    ))
    .sort((a, b) => (
      a.effective_from.localeCompare(b.effective_from)
      || a.amendment_id - b.amendment_id
    ))

  return entityChanges.length > 0
    ? entityChanges[entityChanges.length - 1].new_entity_id
    : baseEntityId
}
